export const ADD_PROMO = "ADD_PROMO"
export const UPDATE_PROMO = "UPDATE_PROMO"
export const REMOVE_PROMO = "REMOVE_PROMO"
export const CLEAR_CART_PROMO = "CLEAR_CART_PROMO"
export const ACTIVE_CART = "ACTIVE_CART";


